import { Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-create-market',
  templateUrl: './create-market.component.html',
  styleUrls: ['./create-market.component.scss']
})
export class CreateMarketComponent {

    constructor(public dialogRef: MatDialogRef<CreateMarketComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ok() {
        this.dialogRef.close({isOk: true});
    }

    cancel() {
        this.dialogRef.close({isCancel: true});
    }
}
